/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function NoIndex({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g strokeLinecap="round" strokeWidth={1.2} clipPath="url(#NoIndex_svg__a)"><path stroke="currentColor" d="M12.412 3.464a6 6 0 0 1-8.468 8.418M8.982 1.373a6 6 0 0 0-7.068 7.25" /><path stroke="currentColor" strokeLinejoin="round" d="m12 12 2.5 2.5M14.498 1.006 1.513 13.99" /><path stroke="#fff" strokeLinejoin="round" d="M12.828 1-.156 13.984" /></g><defs><clipPath id="NoIndex_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;